<template>
  <div class="">
    <div class="w-full">
      <!-- Placeholder -->
      <div class="hidden"> Presentation for WeMake </div>
      <div class="flex my-2 hidden">
        <div id="viewport--player-status"
          class="bg-green-100 border border-green-400 px-4 py-1 text-green-700 rounded-md"></div>
      </div>
       <div class="absolute inset-0 dark:bg-gray-900 z-30 flex flex-col items-center justify-center" v-if="showCurtain">
        <canvas id="dotMatrix" class="absolute inset-0 w-full h-full"></canvas>
      </div>
      <div class="relative w-full bg-gray-900 z-40" style="padding-bottom: 56.25%; transition: all 3s ease-in-out;" id="viewportPlaceholderImage"
       v-on:dblclick="toggleFullScreen">

       <div class="absolute inset-0 dark:bg-black z-40 flex flex-col items-center justify-center" v-if="showCurtain">
        <div class="text-2xl text-shadow-md text-white lg:text-7xl leading-9 font-bold">
          Waiting for host
        </div>
        <div class="text-gray-300 mt-16 text-lg md:text-4xl">The presentation will begin shortly</div>
        <p class="mt-16 text-gray-400 text-sm md:text-2xl text-center">Hint: While you wait, you can upload something <br />to our pinboard, or draw something on here!</p>
       </div>
        <template v-if="(typeof currentMedia) !== 'undefined'">
          <transition :name="selectedAnim">
            <template v-if="currentMedia.media_type === 'image'">
              <img :key="mediaInDisplay" class="absolute w-full h-full object-contain" :src="mediaInDisplay" draggable="false"
                @load="onImageLoad">
            </template>
            <template v-else-if="currentMedia.media_type === 'audio'">
              <div class="absolute bg-black h-full w-full">
                <div class="text-white absolute left-2 top-2 lg:left-10 lg:top-10">
                  <div class="w-16 h-16 lg:h-32 lg:w-32 rounded bg-animated flex items-center justify-center text-sm text-white">
                    <div>
                      Artwork
                    </div>
                  </div>
                  <div class="text-lg font-bold mt-2">
                    Audio file
                  </div>
                  <div class="italic">
                    {{ currentMedia.name || "No title" }}
                  </div>
                  <div class="text-gray-100">
                    {{ "00:00" }}
                    / {{ "01:00" }}
                  </div>
                  <div id="randomAudioBits" class="vt323">
                    ......
                  </div>
                </div>
                <audio :key="mediaInDisplay" id="player" :src="mediaInDisplay"
                  class="absolute left-0 bottom-0 w-full h-full object-contain p-2"></audio>
                <button id="tapToUnmuteButton" style="z-index: 70" type="button"
                  class="flex items-center w-full absolute bottom-0 left-0 right-0 justify-center bg-red-500 cursor-pointer hover:bg-red-600 hidden">
                  <div class="z-10 text-white text-xl font-bold text-center">
                    Tap here to unmute video
                  </div>
                </button>
              </div>
            </template>
            <template v-else-if="currentMedia.media_type === 'video'">
              <div>
              <video muted playsinline :key="mediaInDisplay" :src="mediaInDisplay" id="player" class="absolute w-full h-full object-contain"  draggable="false"></video>
              <button id="tapToUnmuteButton" style="z-index: 70" type="button"
                class="flex items-center w-full absolute bottom-0 left-0 right-0 justify-center bg-red-500 cursor-pointer hover:bg-red-600 hidden">
                <div class="z-10 text-white text-xl font-bold text-center">
                  Tap here to unmute video
                </div>
              </button>
              </div>
            </template>
          </transition>
        </template>
        <video playsinline muted id="shareScreenVideo" class="hidden absolute w-full h-full object-fill"
          style="object-fit: fill"></video>
        <!-- Helper pointer -->
        <div class="hidden laser-pointer absolute" :style="{ top: '10%', left: '10%' }">
          <svg class="-ml-5 -mt-5 h-10 w-10 fill-current text-white" xmlns="http://www.w3.org/2000/svg" stroke="#00000091"
            viewBox="0 0 20 20">
            <path
              d="M16 10c0 .553-.048 1-.601 1H11v4.399c0 .552-.447.601-1 .601-.553 0-1-.049-1-.601V11H4.601C4.049 11 4 10.553 4 10c0-.553.049-1 .601-1H9V4.601C9 4.048 9.447 4 10 4c.553 0 1 .048 1 .601V9h4.399c.553 0 .601.447.601 1z" />
          </svg>
          <div class="bg-red-500 text-white px-1 text-xs">this is another</div>
        </div>
        <div v-for="(p, i) in pointersAsList" class="laser-pointer absolute" :style="{ top: p.y + '%', left: p.x + '%' }"
          :key="'p' + i">
          <!-- Ring icon -->
          <div
            class="-ml-3 -mt-3 h-6 w-6  lg:-ml-5 lg:-mt-5 lg:h-10 lg:w-10 rounded-full bg-transparent border-4 lg:border-3 border-red-500 shadow-md">
          </div>
          <div class="bg-red-500 text-white px-1 text-xs">{{ pointersNamedAsList[i] }}</div>
        </div>
        <!--pointers end -->

        <video :src="preloadedMedia"
          class="hidden absolute bottom-0 right-0 w-32 h-32 object-contain bg-blue-300"></video>
      </div>
        <div class="mt-4 flex space-x-2 hidden">
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">🔥</button>
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">🥳</button>
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">❤️</button>
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">💯</button>
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">👌🏻</button>
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">😐</button>
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">🤮</button>
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">🙋</button>
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">📌</button>
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">👎</button>
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">👍</button>
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">👏</button>
            <button @click="sendReaction('a')" class="grow px-2 py-2 text-lg bg-gray-700 hover:bg-gray-900 rounded-md">✂️</button>
        </div>
    </div>
  </div>
</template>
<script>
import commandsManager from 'general/CommandsManager'
import messageBroker from 'general/messageBroker'
import { detectBrowser } from 'utils/browser';
import Pointers from 'presenter/pointers';


const LOADING = 0 // slide is loading
const CACHED = 1 // slide is cached
const NONE = -1 // Slide has is not laoding and its not cached
export default {
  name: 'presenter-viewport-guest',
  data() {
    return {
      slides: [],
      currentSlideIndex: 0,
      currentMedia: undefined,
      pointers: new Map(),
      pointersName: new Map(),
      pointerTracker: 0,
      PT: 200, // 200 ms
      mouseEvents: [], // this will hold all mouse events
      MINIMUM_LATENCY: 30,
      wait: false,
      eventsPerSecond: 60,
      mediaInDisplay: null,
      preloadedURL: null,
      preloadedMedia: null,
      preloadedMedias: new Map(),
      loadingState: Array(0).fill(NONE),
      selectedAnim: '',
      prevMoves: { x: -9999999, y: -9999999 },
      presentedMedia: null,
      from: null,
      isQuietAudioActive: false,
      playingInterval: null,

      isSafari: false,
      showCurtain: true,
      stopGame: false,
      gameStarted: false,
    }
  },
  methods: {
    sendReaction(str){
      messageBroker.sendMessage({type:"presenter--reaction", reaction: str, peer_key: participant_key}, 'presenter--reaction');
    },
    toggleFullScreen() { // TODO check if feature is allowed on mobile browsers
      if (!document.fullscreenElement) {
        document.querySelector("#viewportPlaceholderImage").requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        }
      }
    },
    onImageLoad() {
      if (this.currentType == 'image') {
        console.log("onImageLoad", this.currentType)

        window.setTimeout(() => {
          this.sendStatusToHost("READY", this.currentSlideIndex, 100)
        }, 100)
      }
    },
    sendStatusToHost(status, index, percentage) {
      messageBroker.sendMessage({type:"presenter--playback_status", status, index, percentage, peer_key: participant_key}, 'presenter--playback_status', this.from);
    },
    toggleCurtain(enabled){
        this.showCurtain = enabled;
        let pinboardWrapper = document.getElementById("pinboard-spacer");
        let pinboard = document.getElementById("pinboard");
        let viewport = document.getElementById("viewportPlaceholderImage");
        if (enabled){
          pinboardWrapper.style.maxHeight = "0px";
          viewport.style.transform = "scale(0.5) translate(50%, -50%)";
          viewport.style.opacity  = 0.5
          this.pointers.enablePointers();
          window.setTimeout(() => {
            this.startSnakeGame();
          }, 250);
        } else{
          this.stopGame = true;
          let pinboardWrapper = document.getElementById("pinboard-spacer");
          pinboardWrapper.style.maxHeight = "12rem";
          this.pointers.disablePointers();
          viewport.style.opacity  = 1
          pinboard.opacity = 0.5
          viewport.style.transform = "scale(1)"
        }
    },
    setupCommands(){
      commandsManager.registerNewCommand('presenter--toggle-curtain', (data) => {
        this.toggleCurtain(data.args.show);
      })

      commandsManager.registerNewCommand('presenter--request-slides-status', (data) => {
        this.slides.forEach((slide, index) => {
          if (this.preloadedMedias.has(index)) {
            this.sendStatusToHost("READY", index, 100)
          } else {
            this.sendStatusToHost("LOADING", index, 0)
          }
        })
      })
      commandsManager.registerNewCommand('play_video_clip', (data) => {
        $("#player")[0].play();
      })
      commandsManager.registerNewCommand('pause_video_clip', (data) => {
        $("#player")[0].pause();
      })
      commandsManager.registerNewCommand('set_time_video_clip', (data) => {
        $("#player")[0].currentTime = data.args.currentTime;
      })
 commandsManager.registerNewCommand('init_presentation', (data) => {
      this.from = data.args.peer_key;
      this.slides = data.args.slides;
      this.loadingState = Array(0).fill(NONE);
      this.preloadedMedias = new Map();
    });

    commandsManager.registerNewCommand('animation_changed', ({ args: { selectedAnim } }) => {
      this.selectedAnim = selectedAnim
    })
    // Observe if host or presentators are presenting media
    commandsManager.registerNewCommand('presenting_media', ({ args: media }) => {
      this.presentedMedia = media;
      this.mediaInDisplay = media.url;
      this.currentMedia = media;
      this.setUpListenerForAudioVideoMedia()
        window.setTimeout(() => {
          if (this.currentType === 'audio' || this.currentType === 'video') {
            if (this.isSafari){
              $("#player")[0].muted = true;
            } else{
              $("#player")[0].volume = this.isQuietAudioActive ? 0.1 : 1;
            }
          }
        }, 300)
    });
    // If presenting media was eneded by escape we should listen this event
    commandsManager.registerNewCommand('finish_presenting_media', () => {
      this.mediaInDisplay = this.preloadedMedias.get(this.currentSlideIndex);
      this.currentMedia = this.slides[this.currentSlideIndex];
    })
    commandsManager.registerNewCommand('quiet_audio', ({ args: { active } }) => {
      this.isQuietAudioActive = active;
      if (this.currentType === 'audio' || this.currentType === 'video') {
        if(this.isSafari == false){
          $("#player")[0].volume = active ? 0.1 : 1;
        }
      }
    })
    },
    setUpListenerForAudioVideoMedia(data) {
      if ((typeof this.currentType) === 'undefined')
        return
      if (this.currentType === 'audio' || this.currentType === 'video') {
        window.setTimeout(() => {
          let player = document.getElementById("player");
          if (player == null) return;
          player.muted = this.isSafari;
          // Show text "Tap to unmute" for safari
          if (this.isSafari) {
            let tapToUnmuteButton = document.querySelector('#tapToUnmuteButton');
            if (tapToUnmuteButton) {
              tapToUnmuteButton.classList.remove('hidden');
              tapToUnmuteButton.onclick = () => {
                player.muted = false;
                tapToUnmuteButton.classList.add('hidden');
              };
            }
          }
          let status = document.getElementById("viewport--player-status");
          let progressUpdater = null;
          player.oncanplaythrough = (e) => {
            this.sendStatusToHost("READY", this.currentSlideIndex, 100)
            status.innerHTML = "Can play through"
          };
          player.onplay = (e) => {
            status.innerHTML = "Playing";
            this.sendStatusToHost("PLAYING", this.currentSlideIndex, (player.currentTime / player.duration * 100))
            // send for every second the current index
            progressUpdater = setInterval(() => {
              this.sendStatusToHost("PLAYING", this.currentSlideIndex, (player.currentTime / player.duration * 100))
            }, 1000)

            // to avoid double calling this, this is weird however
            if (this.playInterval != null) return;
            this.playingInterval = window.setInterval(() => {
              let string = "."
              for (var i = 0; i < 6; i++) {
                const rand = Math.random();
                string += rand > 0.5 + (((i / 2) + 3) / 10) ? "|" : "."
              }
              string += "."
              $("#randomAudioBits").html(string)
            }, 100)

          };
          player.onpause = (e) => {
            status.innerHTML = "Paused"
            this.sendStatusToHost("PAUSED", this.currentSlideIndex, (player.currentTime / player.duration * 100))

            clearInterval(progressUpdater);

            $("#randomAudioBits").html(".....")
            if (this.playingInterval != null) {
              window.clearInterval(this.playingInterval);
              this.playingInterval = null;
            }
          };
          player.onended = (e) => {
            this.sendStatusToHost("ENDED", this.currentSlideIndex, 100)
          };
          player.onprogress = (e) => {
            console.log("Progress", e)
          };
        }, 500)
      }
    },
    downloadVideo(url, data, index, preload = true) {
      url = url + "?t=" + new Date().getTime()
      var req = new XMLHttpRequest();
      req.open('GET', url, true);
      req.responseType = 'blob';

      req.onload = () => {
        // Onload is triggered even on 404
        // so we need to check the status code

        // the image is probably already cached, just show it
        if(req.status === 304) {
        }
        if (req.status === 200) {
          console.log("loaded fully",  this.slides[index].media_type, url,)
          var videoBlob = req.response;
          var vid = URL.createObjectURL(videoBlob); // IE10+
          // Video is now downloaded
          // and we can set it as source on the video element
          if (preload) {
            this.preloadedMedia = vid;
            console.log("setting cache", url, index, this.currentSlideIndex)
            if (typeof (Vue) != "undefined") Vue.set(this.loadingState, index, CACHED)
            this.preloadedMedias.set(index, vid)
            if (index === this.currentSlideIndex){
              this.mediaInDisplay = this.preloadedMedias.get(index)
              this.currentMedia = this.slides[this.currentSlideIndex];
            }
          } else {
            this.mediaInDisplay = vid;
            if (this.currentType === 'audio' || this.currentType === 'video') {
              if (this.isSafari) {
                $("#player")[0].muted = true;
              } else {
                $("#player")[0].volume = this.isQuietAudioActive ? 0.1 : 1;
              }
            }
          }
        }
      }
      req.onprogress = (e) => {

        console.log("progress", url)
        if (e.lengthComputable) {
          var ratio = parseInt(e.loaded / e.total * 100, 10)
          if (ratio == 100) {
            this.sendStatusToHost("READY", index, 100)
          } else {
            console.log("Loading", index, ratio, url, preload)
            this.sendStatusToHost("LOADING", index, ratio)
          }
        }
        if ((e.loaded / e.total) === 1) {
          // finished upload
        }
      };
      req.onerror = function (e) {
        // Error
        console.error("error", e)
      }
      req.send();
    },
    slideChanged(data){
      // wait until we have the slides
      if (this.slides.length == 0){
        console.log("waiting for slides")
        window.setTimeout(() => {
          this.slideChanged(data);
        }, 1000);
      };

      this.currentSlideIndex = data.args;
      this.currentMedia = this.slides[this.currentSlideIndex];

      if (this.preloadedMedias.has(this.currentSlideIndex)) {
        this.mediaInDisplay = this.preloadedMedias.get(this.currentSlideIndex);
        console.log("getting from cache")
        window.setTimeout(() => {
          if (this.currentType === 'audio' || this.currentType === 'video') {
            if (this.isSafari){
              $("#player")[0].muted = true;
            } else{
              $("#player")[0].volume = this.isQuietAudioActive ? 0.1 : 1;
            }
          }
        }, 300)
      } else {
        this.currentMedia = "";
        this.downloadVideo(this.slides[this.currentSlideIndex].url, data, this.currentSlideIndex)
      }

      // Preloading range
      for (let i = 0; i < this.slides.length; i++) {
        if ((i - this.currentSlideIndex) <= 4 && (i - this.currentSlideIndex) >= 0) {
          if (!this.preloadedMedias.has(i)) {
            //console.log(i,i - this.currentSlideIndex, Math.abs(i - this.currentSlideIndex) <= 3)
            let slide = this.slides[i];
            if (this.loadingState[i] === NONE || this.loadingState[i] === undefined) { // if its not loading download the resource
              this.$set(this.loadingState, i, LOADING)
              this.downloadVideo(slide.url, data, i)
            }
          }
        }
      }

      // it is important to set the listeners after changing each slide as the players are different
      this.setUpListenerForAudioVideoMedia(data);
    },
    drawDots(){
    let canvas = document.getElementById("dotMatrix");
    let ctx = canvas.getContext("2d");

    canvas.width =  canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    let w = canvas.width; 
    let h = canvas.height;

    // create a matrix of dots that covers the whole canvas
    let columns = Math.floor(w / 10) + 1;
    let rows = Math.floor(h / 10) + 1;
    let matrix = [];
    for (let y = 0; y < rows; y++) {
      matrix[y] = [];
      for (let x = 0; x < columns; x++) {
        matrix[y][x] = Math.floor(Math.random());
      }
    }

    // create a copy of the dot matrix
    // this copy will be shifted to create the scrolling effect
    let copy = matrix.slice();

    // draw the dot matrix
    function draw() {
      ctx.fillStyle = "#000";
      ctx.fillRect(0, 0, w, h);

      ctx.fillStyle = "#fff";
      for (let y = 0; y < copy.length; y++) {
        for (let x = 0; x < copy[y].length; x++) {
          if (copy[y][x] === 1) {
            // draw a circle
            ctx.beginPath();
            // ctx.arc(x * 10, y * 10, 4, 0, Math.PI * 2);
            ctx.fillRect(x * 10, y * 10, 8, 8);
            ctx.fill();
          }
        }
      }
    }

    // shift one line up
    function step() {
      for (let y = 0; y < matrix.length; y++) {
        for (let x = 0; x < matrix[y].length; x++) {
          // turn off random dots in the matrix
          if (Math.random() > 0.995) {
            matrix[y][x] = 0;
          }
          // turn on new random dots
          if (Math.random() < 0.005) {
            matrix[y][x] = 1;
          }
        }
      }
      // copy the shifted matrix to create the scrolling effect
      copy = matrix.slice();
      // draw the dot matrix
      draw();
    }

    // start the animation loop
    setInterval(step, 1000/12);
    },

    startSnakeGame(){
      if (this.gameStarted){
        return;
      }
      this.gameStarted = true;
      let canvas = document.getElementById("dotMatrix");
      let ctx = canvas.getContext("2d");

      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;

      let w = canvas.width;
      let h = canvas.height;

      // simple 2d matrix snake game
      let width = 10;
      let height = 10;


      let snake = {
        x: 0,
        y: 0,
        dx: width,
        dy: 0,
        cells: [],
        maxCells: 4
      };

      let apple = {
        x: width,
        y: height
      };

      let aiPlaying = true

      let tick = 0;

      function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
      }

      var self = this;
      function loop() {
        if(self.stopGame){
          self.stopGame = false;
          self.gameStarted = false;
          return;
        }
        requestAnimationFrame(loop);
        // slow game loop to 15 fps instead of 60 (60/15 = 4)
        if (++tick < 2) {
          return;
        }
        if (aiPlaying) {
          if (apple.x > snake.x) {
            snake.dx = width;
            snake.dy = 0;
          } else if (apple.x < snake.x) {
            snake.dx = -width;
            snake.dy = 0;
          } else if (apple.y > snake.y) {
            snake.dy = height;
            snake.dx = 0;
          } else if (apple.y < snake.y) {
            snake.dy = -height;
            snake.dx = 0;
          }
        }

        tick = 0;
        ctx.clearRect(0, 0, w, h);

        // write score on the upper left corner
        ctx.fillStyle = 'white';
        ctx.font = '16px VT323';
        ctx.fillText('Score: ' + (snake.cells.length - 4), 20, 20);

        snake.x += snake.dx;
        snake.y += snake.dy;
        // wrap snake position horizontally on edge of screen
        if (snake.x < 0) {
          snake.x = Math.round((canvas.width - width) / width) * width;
          console.log(snake.x)
        } else if (snake.x >= canvas.width) {
          snake.x = 0;
        }

        // wrap snake position vertically on edge of screen
        if (snake.y < 0) {
          snake.y = Math.round((canvas.height - height) / height) * height;
          console.log(snake.y)
        } else if (snake.y >= canvas.height) {
          snake.y = 0;
        }

        // keep track of where snake has been. front of the array is always the head
        snake.cells.unshift({
          x: snake.x,
          y: snake.y
        });

        // remove cells as we move away from them
        if (snake.cells.length > snake.maxCells) {
          snake.cells.pop();
        }

        // draw apple
        ctx.fillStyle = 'red';
        ctx.fillRect(apple.x, apple.y, width, height);

        // draw snake one cell at a time
        ctx.fillStyle = '#0F0';
        snake.cells.forEach(function (cell, index) {

          // drawing 1 px smaller than the grid creates a grid effect in the snake body so you can see how long it is
          ctx.fillRect(cell.x, cell.y, width-1, height-1);

          // snake ate apple
          if (cell.x === apple.x && cell.y === apple.y) {
            snake.maxCells++;
            apple.x = (getRandomInt(0, w / width)-1) * width;
            apple.y = (getRandomInt(0, h / height)-1) * height;
            console.log("ate apple", apple.x, apple.y)
          }

          // check collision with all cells after this one (modified bubble sort)
          for (var i = index + 1; i < snake.cells.length; i++) {

            // snake occupies same space as a body part. reset game
            if (cell.x === snake.cells[i].x && cell.y === snake.cells[i].y) {
              snake.x = 0;
              snake.y = 0;
              snake.cells = [];
              snake.maxCells = 4;
              snake.dx = width;
              snake.dy = 0;
              apple.x = (getRandomInt(0, w/width)-1) * width;
              apple.y = (getRandomInt(0, h/height)-1) * height;
            }
          }
        });
    }

    // listen to keyboard events to move the snake
    document.addEventListener('keydown', function (e) {
      e.preventDefault();
      aiPlaying = false
      // prevent snake from backtracking on itself by checking that it's
      // not already moving on the same axis (pressing left while moving
      // left won't do anything, and pressing right while moving left
      // shouldn't let you collide with your own body)
      // left arrow key
      if (e.which === 37 && snake.dx === 0) {
        snake.dx = -width;
        snake.dy = 0;
      }
      // up arrow key
      else if (e.which === 38 && snake.dy === 0) {
        snake.dy = -height;
        snake.dx = 0;
      }
      // right arrow key
      else if (e.which === 39 && snake.dx === 0) {
        snake.dx = width;
        snake.dy = 0;
      }
      // down arrow key
      else if (e.which === 40 && snake.dy === 0) {
        snake.dy = height;
        snake.dx = 0;
      }
    });

    // start the game
    requestAnimationFrame(loop);

    }

  },

  mounted() {
    let viewportEl = document.querySelector('#viewportPlaceholderImage');
    this.pointers = new Pointers(viewportEl, myId, window.name || participant_name);

    this.toggleCurtain(true);

    const browser = detectBrowser(window);
    this.isSafari = browser.browser === 'safari' && browser.version >= 605 && (browser.iphone || browser.ipad);

    commandsManager.registerNewCommand('slide_changed', (data) => {
      this.slideChanged(data);
    });

    this.setupCommands();
  },
  computed: {
    currentType() {
      if (this.presentedMedia != null) { return this.presentedMedia.media_type };
      if ((typeof this.slides[this.currentSlideIndex]) === 'undefined')
        return undefined;
      return this.slides[this.currentSlideIndex].media_type;
    },
    pointersAsList() {
      // By using `mySetChangeTracker` we tell Vue that this property depends on it,
      // so it gets re-evaluated whenever `mySetChangeTracker` changes
      return this.pointerTracker && Array.from(this.pointers).map(x => x[1]);
    },
    pointersNamedAsList() {
      // By using `mySetChangeTracker` we tell Vue that this property depends on it,
      // so it gets re-evaluated whenever `mySetChangeTracker` changes
      return this.pointerTracker && Array.from(this.pointersName).map(x => x[1]);
    },
  }

}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}</style>
